import { render, staticRenderFns } from "./WsFooter.vue?vue&type=template&id=149174c8"
import script from "./WsFooter.vue?vue&type=script&lang=js"
export * from "./WsFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports